import React, { useEffect } from "react";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { DocumentScanner } from "@mui/icons-material";
import { useRef } from "react";
import { formatSignatureDate } from "../../../utils/formatSignatureDate";
import { connect } from "react-redux";
import moment from "moment";
import { imageToBase64 } from "../../../utils/imageToBase64";
import { uploadCRMDocumentAndGetUrl } from "../../../utils/uploadDocument";
import { post } from "../../../api";

export  const generatePDF = async (data, user, sasToken, isSendToTalentTrail = false, token, candidateId) => {
  const doc = new jsPDF();
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text("Literacy & Numeracy Assessment", 105, 30, { align: "center" });

  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.text("Personal Information", 105, 50, { align: "center" });

  //
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("First Name", 10, 75);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.firstName}`, 10, 85);

  //
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Surname", 10, 95);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.surName}`, 10, 100);

  //
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Home Address", 10, 110);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.homeAddress}`, 10, 115);

  //
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Postcode", 10, 125);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.postCode}`, 10, 130);

  //
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Mobile Number", 10, 140);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.mobile}`, 10, 145);
  //
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Landline Number", 10, 155);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.landlineNumber? data?.landlineNumber : ''}`, 10, 160);
  //
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Email Address", 10, 170);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.email}`, 10, 175);

  // Table Data
  doc.addPage();

  const pageHeight = doc.internal.pageSize.height;
  const pageWidth = doc.internal.pageSize.width;
  const margin = 10;

  doc.setFontSize(10);
  let currentHeight = margin;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text("Assessment", 105, 10, { align: "center" });
  // Set fonts and alignments on the second page
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  doc.text("A = Alpha", 10, 20);
  doc.text("H= Hotel", 10, 30);
  doc.text("O = Oscar", 10, 40);
  doc.text("V = Victor", 10, 50);
  doc.text("B = Bravo", 10, 60);
  doc.text("I = India", 10, 70);
  doc.text("P = Papa", 10, 80);
  doc.text("W = Whiskey", 10, 90);
  doc.text("C = Charlie", 10, 100);
  doc.text("J = Juliet", 10, 110);
  doc.text("Q = Quebec", 10, 120);
  doc.text("X = X-ray", 10, 130);
  doc.text("D = Delta", 10, 140);
  doc.text("K = Kilo", 10, 150);
  doc.text("R = Romeo", 10, 160);
  doc.text("Y = Yankee", 10, 170);
  doc.text("E = Echo", 10, 180);
  doc.text("L = Lima", 10, 190);
  doc.text("S = Sierra", 10, 200);
  doc.text("Z = Zulu", 10, 210);
  doc.text("F = Foxtrot", 10, 220);
  doc.text("M = Mike", 10, 230);
  doc.text("T = Tango", 10, 240);
  doc.text("G = Golf", 10, 250);
  doc.text("N = November", 10, 260);
  doc.text("U = Uniform", 10, 270);
  doc.text(
    "Using the phonetic alphabet above provided, please complete the questions below.",
    10,
    280
  );
  doc.setFont("helvetica", "bold");
  doc.text("Example : Kevin = Kilo, Echo, Victor, India, November", 10, 300);

  doc.addPage();
  //
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Simon:", 10, 20);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.simon}`, 10, 25);

  //
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Jennifer:", 10, 35);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.jennifer}`, 10, 40);

  //
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("September:", 10, 50);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.september}`, 10, 55);

  //
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Please complete the following numeric questions:", 10, 80);
  doc.setFontSize(10);
  doc.text(`5 x 8 = ${data?.answer1}`, 10, 90);
  doc.text(`6 x 9 = ${data?.answer2}`, 10, 100);
  doc.text(`7 x 4 = ${data?.answer3}`, 10, 110);
  doc.text(`8 x 6 = ${data?.answer4}`, 10, 120);
  doc.text(`3 x 12 = ${data?.answer5}`, 10, 130);
  doc.text(`14 + 3+ 9 – 2 = ${data?.answer6}`, 10, 140);
  doc.text(`½ + ¼ = ${data?.answer7}`, 10, 150);
  doc.text(`1.5 x 4 = ${data?.answer8}`, 10, 160);
  doc.text(`15 x 100 = ${data?.answer9}`, 10, 170);
  doc.text(`1000 / 4 = ${data?.answer10}`, 10, 180);

  doc.addPage();
  currentHeight = 20;

  // Set bold text on the left
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Signable Form Title", margin, currentHeight); // Add bold text on the left
  doc.setFont("helvetica", "normal");
  doc.text("Literacy & Numeracy Assessment", pageWidth * 0.4, currentHeight); // Add the normal text 30% from the left

  currentHeight += 10;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Signable Form Provided by", margin, currentHeight); // Add bold text on the left
  doc.setFont("helvetica", "normal");
  doc.text("Rapid Resourcing", pageWidth * 0.4, currentHeight); // Add the normal text 30% from the left
  currentHeight += 10;

  doc.line(margin, currentHeight, pageWidth - margin, currentHeight); // Draw a horizontal line across the page
  currentHeight += 10; // Move down a little to make space for the paragraph
  // Add paragraph text after the line
  const paragraphText = `By signing this page, I confirm that I fully understand the content and agree to adhere to it at all times. I also agree that all the details provided in this document are accurate and complete to the best of my knowledge.`;

  // Use splitTextToSize to fit the paragraph within the page width
  const paragraphLines = doc.splitTextToSize(
    paragraphText,
    pageWidth - 2 * margin
  );

  // Add the paragraph to the document
  doc.setFontSize(10);
  doc.text(paragraphLines, margin, currentHeight); // Render paragraph
  currentHeight += 20;

  // Add paragraph text after the line
  const paragraphText2 = `By ticking this box I consent to the company processing my data and the evidence of this document being stored within their system for the purpose of work finding services.`;

  // Use splitTextToSize to fit the paragraph within the page width
  const paragraphLines2 = doc.splitTextToSize(
    paragraphText2,
    pageWidth - 2 * margin
  );

  // Add the paragraph to the document
  doc.text(paragraphLines2, margin, currentHeight); // Render paragraph
  currentHeight += 40;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Date Signed", margin, currentHeight); // Add bold text on the left
  doc.setFont("helvetica", "normal");
  doc.text(`${data?.signDate ? moment(data?.signDate).format("DD-MM-YYYY") : '--'}`, pageWidth * 0.4, currentHeight); // Add the normal text 30% from the left
  currentHeight += 10;

  // Add signature image from URL
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Signature", margin, currentHeight);

  // Add the signature image if the URL exists
  if (data?.signature) {
    try {
      const imgData = await imageToBase64(`${data.signature}?${sasToken}`);
      doc.addImage(imgData, "JPEG", pageWidth * 0.4, currentHeight, 30, 15);
    } catch (e) {
      console.error("Error loading signature image:", e);
    }
  }
  currentHeight += 20;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Name", margin, currentHeight); // Add bold text on the left
  doc.setFont("helvetica", "normal");
  doc.text(
    `${user?.firstName} ${user?.lastName}`,
    pageWidth * 0.4,
    currentHeight
  ); // Add the normal text 30% from the left
  currentHeight += 10;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("IP Address", margin, currentHeight); // Add bold text on the left
  doc.setFont("helvetica", "normal");
  doc.text(`${data?.ipAddress}`, pageWidth * 0.4, currentHeight); // Add the normal text 30% from the left
  currentHeight += 10;

  // Save the PDF
  if (isSendToTalentTrail) {
    const pdfBlob = doc.output("blob");
    const formData = new FormData();
    formData.append(
      "file",
      pdfBlob,
      `literacy-numeracy-assessment-${user?.firstName}-${user?.lastName}.pdf`
    );
    formData.append("candidateId", candidateId);
    const documentUrl =
      (await uploadCRMDocumentAndGetUrl(formData, token)) || "";
    console.log("documentUrl", documentUrl);
    if (documentUrl) {
      const payload = {
        candidateId,
        fileName: `literacy-numeracy-assessment-${user?.firstName}-${user?.lastName}.pdf`,
        fileExtention: ".pdf",
        fileType: "workExperience",
        fileLink: documentUrl,
        licenseNo: "rapidresourcing",
      };

      const url = "/api/candidate/save-document";
      try {
        const res2 = await post(url, payload);
        console.log("Document saved successfully:", res2.data);
      } catch (error) {
        console.error("Error saving document:", error);
      }
    } else {
      console.error("Failed to upload document, skipping save.");
    }
  } else {
    doc.save(`literacy-numeracy-assessment-${user?.firstName}-${user?.lastName}.pdf`);
  }
};
const LiteracyNumeracyDownload = ({ data, sasToken, user }) => {
  const signatureRef = useRef(null); // Create a reference to the image element
  useEffect(() => {
    if (signatureRef.current) {
      // Set the crossOrigin attribute to allow cross-origin image loading
      signatureRef.current.crossOrigin = 'anonymous';
    }
  }, []);
 
  return (
    <>
      <div className="text-center p-4 document-sign">
        <p>{formatSignatureDate(data?.signDate, user)}</p>
        <div>
          {data?.signature && (
            <img ref={signatureRef} src={`${data?.signature}?${sasToken}`} />
          )}
        </div>
      </div>
      <div className="text-center w-100 mt-4">
        <button className="btn btn-success btn-lg" onClick={() => generatePDF(data, user, sasToken)}>
          <DocumentScanner /> Download your receipt
        </button>
      </div>
    </>
  );
};
const mapStateToProps = (state) => ({});
export default connect(mapStateToProps, {})(LiteracyNumeracyDownload);
